export class OrganizationType {
  organizationTypeUuid: string;
  name: string;
  root: boolean;
  readOnly: boolean;
}
